import {
  REPORT_ACCOUNTS,
  REPORT_BILLING_RESULTS,
  REPORT_PROFESSIONAL_TRANSFER,
  REPORT_SENDING_INVOICES,
} from '@/data/actions/modules/financial';
import ProductionProfessionalReport from './components/ProductionProfessionalReport.vue';
import ProductionInsuranceReport from './components/ProductionInsuranceReport.vue';
import ProductionExpenseReport from './components/ProductionExpenseReport.vue';
import GuidesToBillReport from './components/GuidesToBillReport.vue';
import GuidesExpiredReport from './components/GuidesExpiredReport.vue';
import BillingFunnelReport from './components/BillingFunnelReport.vue';
import BatchesByCompetenceReport from './components/BatchesByCompetenceReport.vue';
import BatchesProtocolsReport from './components/BatchesProtocolsReport.vue';
import BatchesOpenReport from './components/BatchesOpenReport.vue';
import StatementCheckReport from './components/StatementCheckReport.vue';
import GlossesByReasonReport from './components/GlossesByReasonReport.vue';
import GlossesByInsuranceReport from './components/GlossesByInsuranceReport.vue';
import GlossesByProfessionalReport from './components/GlossesByProfessionalReport.vue';
import AppealsStatusReport from './components/AppealsStatusReport.vue';
import AppealsDeadlineReport from './components/AppealsDeadlineReport.vue';
import ReceivablesAgingReport from './components/ReceivablesAgingReport.vue';
import PaymentTimeReport from './components/PaymentTimeReport.vue';
import PaymentsBatchReport from './components/PaymentsBatchReport.vue';
import InvoicesBatchReport from './components/InvoicesBatchReport.vue';
import TransferProfessionalReport from './components/TransferProfessionalReport.vue';
import TransferInsuranceReport from './components/TransferInsuranceReport.vue';
import TransferForecastReport from './components/TransferForecastReport.vue';

export const GROUPS = [
  { key: 'production', label: 'Produção e faturamento' },
  { key: 'batches', label: 'Lotes e envio' },
  { key: 'glosses', label: 'Glosas e recursos' },
  { key: 'receiving', label: 'Recebimento' },
  { key: 'transfers', label: 'Repasse' },
];

export const REPORTS = [
  {
    key: 'production-professional',
    group: 'production',
    label: 'Produção por profissional',
    description: 'Itens realizados por profissional no período, com valor de convênio e particular.',
    permission: REPORT_BILLING_RESULTS,
    component: ProductionProfessionalReport,
  },
  {
    key: 'production-insurance',
    group: 'production',
    label: 'Produção por convênio e plano',
    description: 'Quanto cada convênio e plano produziu no período, por tipo de guia.',
    permission: REPORT_BILLING_RESULTS,
    component: ProductionInsuranceReport,
  },
  {
    key: 'production-expense',
    group: 'production',
    label: 'Produção por procedimento',
    description: 'Procedimentos mais realizados, com quantidade e valor por convênio.',
    permission: REPORT_BILLING_RESULTS,
    component: ProductionExpenseReport,
  },
  {
    key: 'guides-to-bill',
    group: 'production',
    label: 'Guias a faturar',
    description: 'Guias registradas ainda sem lote, separadas por tempo de espera.',
    permission: REPORT_ACCOUNTS,
    component: GuidesToBillReport,
  },
  {
    key: 'guides-expired',
    group: 'production',
    label: 'Guias fora do prazo de apresentação',
    description: 'Guias que passaram do prazo do convênio e tendem a virar perda.',
    permission: REPORT_ACCOUNTS,
    component: GuidesExpiredReport,
  },
  {
    key: 'billing-funnel',
    group: 'production',
    label: 'Produção, faturado e recebido',
    description: 'Comparativo por competência entre o que foi produzido, faturado e recebido.',
    permission: REPORT_BILLING_RESULTS,
    component: BillingFunnelReport,
  },
  {
    key: 'batches-competence',
    group: 'batches',
    label: 'Lotes por competência e convênio',
    description: 'Lotes fechados no período, com guias, valor e situação.',
    permission: REPORT_SENDING_INVOICES,
    component: BatchesByCompetenceReport,
  },
  {
    key: 'batches-protocols',
    group: 'batches',
    label: 'Protocolos de envio',
    description: 'Lote, data de envio, protocolo da operadora e situação do protocolo.',
    permission: REPORT_SENDING_INVOICES,
    component: BatchesProtocolsReport,
  },
  {
    key: 'batches-open',
    group: 'batches',
    label: 'Lotes em aberto por tempo de envio',
    description: 'Lotes enviados sem retorno, ordenados pelo tempo de espera.',
    permission: REPORT_SENDING_INVOICES,
    component: BatchesOpenReport,
  },
  {
    key: 'statement-check',
    group: 'batches',
    label: 'Conferência do demonstrativo',
    description: 'Informado, processado e pago por guia, com a diferença apurada.',
    permission: REPORT_BILLING_RESULTS,
    component: StatementCheckReport,
  },
  {
    key: 'glosses-reason',
    group: 'glosses',
    label: 'Glosas por motivo',
    description: 'Códigos da Tabela 38 que mais glosam, com valor e participação.',
    permission: REPORT_BILLING_RESULTS,
    component: GlossesByReasonReport,
  },
  {
    key: 'glosses-insurance',
    group: 'glosses',
    label: 'Glosas por convênio',
    description: 'Percentual glosado sobre o faturado de cada convênio.',
    permission: REPORT_BILLING_RESULTS,
    component: GlossesByInsuranceReport,
  },
  {
    key: 'glosses-professional',
    group: 'glosses',
    label: 'Glosas por profissional',
    description: 'Glosas atribuídas a cada profissional e o efeito no repasse.',
    permission: REPORT_BILLING_RESULTS,
    component: GlossesByProfessionalReport,
  },
  {
    key: 'appeals-status',
    group: 'glosses',
    label: 'Recursos e recuperação',
    description: 'Recursos enviados, respondidos e o quanto foi recuperado.',
    permission: REPORT_BILLING_RESULTS,
    component: AppealsStatusReport,
  },
  {
    key: 'appeals-deadline',
    group: 'glosses',
    label: 'Prazos de recurso a vencer',
    description: 'Glosas sem decisão com o prazo contratual de recurso correndo.',
    permission: REPORT_BILLING_RESULTS,
    component: AppealsDeadlineReport,
  },
  {
    key: 'receivables-aging',
    group: 'receiving',
    label: 'Contas a receber de convênio',
    description: 'Títulos dos lotes por faixa de vencimento, com o que já venceu.',
    permission: REPORT_BILLING_RESULTS,
    component: ReceivablesAgingReport,
  },
  {
    key: 'payment-time',
    group: 'receiving',
    label: 'Prazo médio de recebimento',
    description: 'Dias entre o envio do lote e o pagamento, por operadora.',
    permission: REPORT_BILLING_RESULTS,
    component: PaymentTimeReport,
  },
  {
    key: 'payments-batch',
    group: 'receiving',
    label: 'Pagamentos recebidos por lote',
    description: 'Baixas vindas do demonstrativo de pagamento, com débitos e créditos.',
    permission: REPORT_BILLING_RESULTS,
    component: PaymentsBatchReport,
  },
  {
    key: 'invoices-batch',
    group: 'receiving',
    label: 'Notas fiscais por lote',
    description: 'Lotes que exigem nota fiscal, emitidas e pendentes.',
    permission: REPORT_BILLING_RESULTS,
    component: InvoicesBatchReport,
  },
  {
    key: 'transfer-professional',
    group: 'transfers',
    label: 'Repasse por profissional',
    description: 'Repasse do período por profissional, com os ajustes de glosa.',
    permission: REPORT_PROFESSIONAL_TRANSFER,
    component: TransferProfessionalReport,
  },
  {
    key: 'transfer-insurance',
    group: 'transfers',
    label: 'Repasse por convênio',
    description: 'Quanto de cada convênio vira repasse e quanto fica na clínica.',
    permission: REPORT_PROFESSIONAL_TRANSFER,
    component: TransferInsuranceReport,
  },
  {
    key: 'transfer-forecast',
    group: 'transfers',
    label: 'Repasse previsto e pago',
    description: 'Repasse calculado, já pago e o que continua em aberto.',
    permission: REPORT_PROFESSIONAL_TRANSFER,
    component: TransferForecastReport,
  },
];

export function reportsOf(group) {
  return REPORTS.filter(report => report.group === group);
}
